
export const ResultScreen = () => `
        <div id="result-screen" class="screen">
            <h2 class="screen-title">SONUÇ</h2>
            <div class="result-box glass-panel">
                <p>TOPLAM PUAN</p>
                <h1 id="final-score">0</h1>

                <div id="result-stats"
                    style="margin: 1rem 0; display: flex; gap: 2rem; justify-content: center; font-size: 1.2rem;">
                    <span style="color: #4caf50;">✅ Doğru: <b id="correct-count">0</b></span>
                    <span style="color: #f44336;">❌ Yanlış: <b id="wrong-count">0</b></span>
                </div>

                <p id="result-message">Fena değil...</p>
            </div>
            <button id="restart-btn" class="gaddar-btn">YENİDEN DENE</button>
        </div>
`;
